/**
 * useShellViewer - this viewer's preferences, and the actor's reach on the map.
 *
 * - `followTurn`: opt-in (v8.331.5) - unset means off, as the registry says.
 * - `reach` (v8.323.0): the actor's relation to every marker - one
 *   `relateFrom` per change, feeding the map's marks. Only for an armed
 *   RANGED weapon; derived, never stored.
 *
 * Extracted from DeathWatchSimulator.
 */
import { useMemo, useSyncExternalStore } from 'react';
import { getViewerPrefs, subscribeViewerPrefs } from '../utils/viewerPrefs';
import useRelations, { reachFrom } from './useRelations';

/** The prefs the shell reads, from the stored record. */
export function viewerChoices(prefs) {
  return {
    followTurn: prefs.followTurn === true,
  };
}

/** @param {object} args - actorId, tokens, mapSolids, weaponRange, isGm, slot, isMelee, relationRules. */
export default function useShellViewer(args) {
  const { actorId, tokens, mapSolids, weaponRange, isGm, slot, isMelee, relationRules } = args;
  const prefs = useSyncExternalStore(subscribeViewerPrefs, getViewerPrefs, getViewerPrefs);
  const relations = useRelations({
    actorId,
    tokens,
    solids: mapSolids,
    weaponRange,
    isGm,
    enabled: !!slot && !slot.isEmpty && !isMelee,
    relationRules,
  });
  const reach = useMemo(() => reachFrom(relations), [relations]);
  return { ...viewerChoices(prefs), reach };
}
